"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var metrics_engine_1 = require("@tableau/metrics-engine");
/**
 * `MetricValuePill` formats the number it is given according to metrics formatting rules
 * and displays it as a "pill": a blue background with rounded corners, with white text.
 *
 * The pill will fill whatever container it is placed in.
 *
 */
exports.MetricValuePill = function (props) {
    var _a;
    var text = metrics_engine_1.formatValueAsMetricNumber(props.value, props.measureFormat);
    return (React.createElement("div", { style: __assign(__assign({}, pillStyle), { backgroundColor: (_a = props.color, (_a !== null && _a !== void 0 ? _a : metrics_engine_1.MetricsNeutralColor)) }), title: text, "data-tb-test-id": 'metric-value-pill' }, text));
};
var pillStyle = {
    borderRadius: 2,
    color: 'white',
    fontSize: 14,
    fontWeight: 'normal',
    lineHeight: 'normal',
    width: '100%',
    height: '100%',
    paddingLeft: '5px',
    paddingRight: '5px',
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'center',
    alignItems: 'center',
};
//# sourceMappingURL=MetricValuePill.js.map